import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@fgb/core';
import { ErrorStateService } from '@fgb/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { gsap } from 'gsap';
import { fromEvent } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'fgb-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: ['./maintenance-page.component.scss'],
})
export class MaintenancePageComponent implements OnInit {
  showAppleLink = true;
  showGoogleLink = true;
  private _destroyRef = inject(DestroyRef);
  private mm = gsap.matchMedia();

  constructor(
    private router: Router,
    public errorService: ErrorStateService,
    private authService: AuthService,
    public deviceDetector: DeviceDetectorService
  ) {
    this.authService.checkApiStatus();

    if (this.authService.hasCurrentRefreshToken()) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.downloadAppLink();
    // Perform the background movement effect only for larger screens
    this.mm.add('screen and (min-width: 991px)', () => {
      const subscription = fromEvent(window, 'mousemove')
        .pipe(takeUntilDestroyed(this._destroyRef))
        .subscribe((e: any) => {
          const percentX = e.clientX / window.innerWidth;
          const percentY = e.clientY / window.innerHeight;

          const moveX = (percentX - 0.5) * 30;
          const moveY = (percentY - 0.5) * 30;

          gsap.to('.full-page', {
            backgroundPosition: `${50 + moveX}% ${50 + moveY}%`,
            duration: 0.4,
            ease: 'power3.out',
          });
        });
      return () => {
        subscription.unsubscribe();
      };
    });
  }

  downloadAppLink() {
    if (this.deviceDetector.os.match('iOS')) {
      this.showGoogleLink = false;
    } else if (this.deviceDetector.os.match('Android')) {
      this.showAppleLink = false;
    }
  }
}
